import React, { FC, useState } from "react";
import { useLocation } from "react-router-dom";

import { IRoute, history } from "configs";
import {
  Badge,
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  ArrowDropUp as ArrowUpIcon,
  ArrowDropDown as ArrowDownIcon,
} from "@mui/icons-material";

export const SidebarListCollapsable: FC<{
  route: IRoute;
  children: React.ReactElement;
  leftSpace?: number;
  badgeContent?: number;
}> = ({ route, children, leftSpace = 0, badgeContent }) => {
  const location = useLocation();
  const open = location?.pathname?.startsWith(route.routes ? route.path : "");
  const [collapse, setCollapse] = useState(!!open);

  return (
    <>
      <ListItemButton
        onClick={() => {
          setCollapse(!collapse);
          if (route.component && collapse) {
            history.push(route.path);
          }
        }}
        dense
        sx={{ pl: leftSpace * 2 }}
      >
        <Badge
          badgeContent={badgeContent}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          color="secondary"
        >
          <ListItemIcon>{route.icon && <route.icon />}</ListItemIcon>
        </Badge>
        <ListItemText primary={route.label} />
        {collapse ? <ArrowUpIcon /> : <ArrowDownIcon />}
      </ListItemButton>
      <Collapse in={collapse}>{children}</Collapse>
    </>
  );
};
